import { Component } from "react";
import axios from "./api.service";

export default class AdminService extends Component {
	static async signIn(login) {
		return axios.post(`/admin/login`, login);
	}

	static getControl() {
		return axios
			.get(`/admin/control`)
			.then((res) => {
				return res.data.control_cookie;
			})
			.catch((err) => console.error);
	}
}
